<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      title="消息中心"></van-nav-bar>
    <div class="container">
      <div class="title">
        {{ msg.title }}
      </div>
      <!-- <div class="content">{{ msg.mesContent }}</div> -->
      <div class="content" v-html="msg.mesContent"></div>
    </div>
  </div>
</template>

<script>
import { read } from "@/api/msg"
export default {
  data: () => ({
    msg: {}
  }),
  beforeMount() {
    const id = this.$route.params.id
    read(id)
      .then((data) => {
        this.msg = data
      })
      .catch((e) => {
        console.error(e)
      })
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 20px 10px;
  margin: 10px;
  background: #fff;
  border-radius: 3px;

  .title {
    font-size: 15px;
    font-weight: bold;
  }
  .content {
    margin-top: 15px;
  }
}
</style>
